import { service } from '@/ajax/request'
import { Id } from '@/types/common'
import { FreightAdd } from '@/types/api/freight'


// 添加运费模版
export const freightAdd = (params: Array<FreightAdd>) => (
  service({
    url: '/pms/freightTemplate/batchSave',
    method: 'POST',
    params
  })
)

// 根据ID删除运费模版
export const freightDel = (params: Id) => (
  service({
    url: `/pms/freightTemplate/delete/${params.id}`,
    method: 'POST',
    params
  })
)

// 选择模板
export const freightSelectCode = (params: Id) => (
  service({
    url: `/pms/freightTemplate/selectByTemplateCode`,
    method: 'GET',
    params
  })
)

// 查询运费模版，当条件没有条件就查所有
export const freightSelectByObj = (params?: FreightAdd) => (
  service({
    url: `/pms/freightTemplate/selectByTemplateObj`,
    method: 'GET',
    params
  })
)

// 更新运费模版 通过code
export const updateByTemplateCode = (code: number, params?: Array<FreightAdd>) => (
  service({
    url: `/pms/freightTemplate/updateByTemplateCode/${code}`,
    method: 'post',
    params
  })
)

// 所有的快递信息
export const expressCompanyList = () => (
  service({
    url: `/omsOrderExpress/expressCompanyList`,
    method: 'post',
    type: 'form'
  })
)